type Subscriber<T> = (data: T) => void;

/**
 * Class that implements Publish/Subscribe pattern
 * The Publish/Subscribe pattern, also known as pub/sub,
 * is an architectural design pattern
 * that provides a framework for exchanging messages between publishers and subscribers.
 */
export class PubSub<T> {
  subscribers: Array<Subscriber<T>>;

  data: T;

  constructor(data: T) {
    this.subscribers = [];
    this.data = data;
  }

  subscribe(subscriber: Subscriber<T>) {
    this.subscribers.push(subscriber);
  }

  get() {
    return this.data;
  }

  unsubscribe(subscriber: Subscriber<T>) {
    this.subscribers = this.subscribers.filter((s) => s !== subscriber);
  }

  publish(data: T) {
    this.data = data;
    this.subscribers.forEach((subscriber) => subscriber(data));
  }
}
